._sidebar_1bn7a_1 {
  position: relative;
  width: 100%;
  height: 100%; }

._bg_1bn7a_6 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1; }

._content_1bn7a_14 {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  z-index: 2; }

._chat_1bn7a_22 {
  flex: 1;
  min-height: 0; }

._header_1bn7a_26 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px; }
  ._header_1bn7a_26 h3 {
    line-height: 1em !important; }
  ._headerLeft_1bn7a_33, ._headerRight_1bn7a_33 {
    display: flex;
    align-items: center; }

._betaBadge_1bn7a_37 {
  margin-left: 8px; }

._footer_1bn7a_40 {
  display: grid;
  grid-template-rows: 1fr;
  transition: grid-template-rows 0.3s ease-in-out; }
  ._footerInner_1bn7a_44 {
    overflow: hidden; }
  ._footerHidden_1bn7a_46 {
    grid-template-rows: 0fr; }
  ._footer_1bn7a_40 * {
    color: #868aa5 !important; }

._themeOriginal_1bn7a_51 {
  background: #fff; }
  ._themeOriginal_1bn7a_51 ._header_1bn7a_26 {
    position: relative;
    box-shadow: 0px 4px 10px 0px rgba(46, 0, 228, 0.04), 0px 2px 2px 0px rgba(0, 0, 0, 0.03);
    z-index: 2;
    padding-right: 6px; }
    ._themeOriginal_1bn7a_51 ._header_1bn7a_26 h3 {
      background: linear-gradient(266.92deg, #5ff2cf -70.28%, #0e53fd 100%);
      -webkit-background-clip: text;
              background-clip: text;
      color: transparent;
      font-size: 16px !important; }
  ._themeOriginal_1bn7a_51 ._headerRight_1bn7a_33 path {
    color: #116dff !important; }
  ._themeOriginal_1bn7a_51 ._footerContent_1bn7a_65 {
    padding: 12px 18px;
    border-top: 1px solid #dfe5eb; }

._themeLight_1bn7a_69 ._header_1bn7a_26, ._themeDark_1bn7a_69 ._header_1bn7a_26 {
  padding-right: 11px; }
  ._themeLight_1bn7a_69 ._header_1bn7a_26 h3, ._themeDark_1bn7a_69 ._header_1bn7a_26 h3 {
    font-size: 12px !important;
    font-weight: 800 !important;
    letter-spacing: 0.1em !important;
    text-transform: uppercase; }

._themeLight_1bn7a_69 ._footerContent_1bn7a_65, ._themeDark_1bn7a_69 ._footerContent_1bn7a_65 {
  padding: 0 24px 18px 24px;
  text-align: center; }

._themeLight_1bn7a_69 ._header_1bn7a_26 h3 {
  color: #000624 !important; }

._themeLight_1bn7a_69 ._headerRight_1bn7a_33 path {
  color: #333853 !important; }

._themeLight_1bn7a_69 ._betaBadge_1bn7a_37 {
  border-color: #333853 !important;
  background: transparent !important; }
  ._themeLight_1bn7a_69 ._betaBadge_1bn7a_37 * {
    color: #333853 !important; }

._themeDark_1bn7a_69 ._header_1bn7a_26 h3 {
  color: #fff !important; }

._themeDark_1bn7a_69 ._betaBadge_1bn7a_37 {
  border-color: #fff !important;
  background: transparent !important; }
  ._themeDark_1bn7a_69 ._betaBadge_1bn7a_37 * {
    color: #fff !important; }
